export const PRACTICE_SETTING_RADIOS = [
  { label: "I'm a solo practitioner", value: "solo practitioner" },
  {
    label:
      "I work for an organization, such as a group practice, non-profit, or a hospital",
    value: "organization",
  },
];

export const VIDEO_LINK_OPTIONS = [
  { label: "Orchid Video Room", value: "orchid_video_room" },
  { label: "Zoom Meeting", value: "zoom_meeting" },
  { label: "Google Meet", value: "google_meet" },
];

export const TELEHEALTH_POS_OPTIONS = [
  {
    label: "02 - Telehealth Provided Other than in Patient's Home",
    value: "02",
  },
  { label: "10 - Telehealth", value: "10" },
];

export const IN_PERSON_POS_OPTIONS = [
  { label: "01 - Pharmacy", value: "01" },
  { label: "03 - School", value: "03" },
  { label: "04 - Homeless Shelter", value: "04" },
  { label: "05 - Indian Health Service - Free-standing Facility", value: "05" },
  {
    label: "06 - Indian Health Service - Provider-based Facility",
    value: "06",
  },
  { label: "07 - Tribal 638 - Free-standing Facility", value: "07" },
  { label: "08 - Tribal 638 - Provider-based Facility", value: "08" },
  { label: "09 - Prison/Correctional Facility", value: "09" },
  { label: "11 - Office", value: "11" },
  { label: "12 - Home", value: "12" },
  { label: "13 - Assisted Living Facility", value: "13" },
  { label: "14 - Group Home", value: "14" },
  { label: "15 - Mobile Unit", value: "15" },
  { label: "16 - Temporary Lodging", value: "16" },
  { label: "17 - Walk-in Retail Health Clinic", value: "17" },
  { label: "18 - Place of Employment", value: "18" },
  { label: "19 - Off Campus - Outpatient Hospital", value: "19" },
  { label: "20 - Urgent Care Facility", value: "20" },
  { label: "21 - Inpatient Hospital", value: "21" },
  { label: "22 - On Campus - Outpatient Hospital", value: "22" },
  { label: "23 - Emergency Room - Hospital", value: "23" },
  { label: "24 - Ambulatory Surgical Center", value: "24" },
  { label: "25 - Birthing Center", value: "25" },
  { label: "26 - Military Treatment Facility", value: "26" },
  { label: "27 - Outreach Site/Street", value: "27" },
  { label: "31 - Skilled Nursing Facility", value: "31" },
  { label: "32 - Nursing Facility", value: "32" },
  { label: "33 - Custodial Care Facility", value: "33" },
  { label: "34 - Hospice", value: "34" },
  { label: "41 - Ambulance - Land", value: "41" },
  { label: "42 - Ambulance - Air or Water", value: "42" },
  { label: "49 - Independent Clinic", value: "49" },
  { label: "50 - Federally Qualified Health Center", value: "50" },
  { label: "51 - Inpatient Psychiatric Facility", value: "51" },
  { label: "52 - Psychiatric Facility - Partial Hospitalization", value: "52" },
  { label: "53 - Community Mental Health Center", value: "53" },
  {
    label:
      "54 - Intermediate Care Facility / Individuals with Intellectual Disabilities",
    value: "54",
  },
  {
    label: "55 - Residential Substance Abuse Treatment Facility",
    value: "55",
  },
  {
    label: "56 - Psychiatric Residential Treatment Center",
    value: "56",
  },
  {
    label: "57 - Non-residential Substance Abuse Treatment Facility",
    value: "57",
  },
  {
    label: "58 - Non-residential Opioid Treatment Facility",
    value: "58",
  },
  { label: "60 - Mass Immunization Center", value: "60" },
  {
    label: "61 - Comprehensive Inpatient Rehabilitation Facility",
    value: "61",
  },
  {
    label: "62 - Comprehensive Outpatient Rehabilitation Facility",
    value: "62",
  },
  {
    label: "65 - End-Stage Renal Disease Treatment Facility",
    value: "65",
  },
  {
    label: "66 - Programs of All-Inclusive Care for the Elderly (PACE) Center",
    value: "66",
  },
  { label: "71 - Public Health Clinic", value: "71" },
  { label: "72 - Rural Health Clinic", value: "72" },
  { label: "81 - Independent Laboratory", value: "81" },
  { label: "99 - Other Place of Service", value: "99" },
];

export const TELEHEALTH_MODIFIER_OPTIONS = [
  { label: "GT", value: "GT" },
  { label: "95", value: "95" },
];

export const MODIFIER_OPTIONS = [
  {
    value: "25",
    label:
      "25 - Significant, separately identifiable evaluation and management (E/M) service by the same physician or other qualified health care professional on the same day of the procedure or other service",
  },
  {
    value: "27",
    label: "27 - Multiple outpatient hospital E/M encounters on the same date",
  },
  { value: "50", label: "50 - Bilateral procedure" },
  { value: "52", label: "52 - Reduced services" },
  { value: "59", label: "59 - Distinct procedural service" },
  { value: "AE", label: "AE - Registered dietitian" },
  { value: "AF", label: "AF - Physician delivering SUD group counseling" },
  { value: "AH", label: "AH - Clinical psychologist" },
  { value: "AM", label: "AM - Physician, team member (ACT)" },
  {
    value: "GN",
    label:
      "GN - Services delivered under an outpatient speech language pathology plan of care",
  },
  {
    value: "GO",
    label:
      "GO - Services delivered under an outpatient occupational therapy plan of care",
  },
  {
    value: "GP",
    label:
      "GP - Services delivered under an outpatient physical therapy plan of care",
  },
  // { value: "GT", label: "GT - Identifies a service as telehealth" },
  { value: "H9", label: "H9 - Court-ordered" },
  { value: "HA", label: "HA - Child/adolescent program" },
  { value: "HB", label: "HB - Adult program, non geriatric" },
  { value: "HC", label: "HC - Adult program, geriatric" },
  { value: "HD", label: "HD - Buprenorphine, generic, per 1 mg" },
  { value: "HE", label: "HE - Mental health program" },
  { value: "HF", label: "HF - Substance abuse program" },
  { value: "HG", label: "HG - Opioid addiction treatment program" },
  {
    value: "HH",
    label: "HH - Integrated mental health/substance abuse program",
  },
  {
    value: "HI",
    label:
      "HI - Integrated mental health and intellectual disability/developmental disabilities program",
  },
  { value: "HJ", label: "HJ - Employee assistance program" },
  {
    value: "HK",
    label: "HK - Specialized mental health programs for high-risk populations",
  },
  { value: "HL", label: "HL - Intern" },
  { value: "HM", label: "HM - Less than bachelor degree level" },
  { value: "HN", label: "HN - Bachelor's degree level" },
  { value: "HO", label: "HO - Master's level degree" },
  { value: "HP", label: "HP - Doctoral level" },
  { value: "HQ", label: "HQ - Group setting" },
  { value: "HR", label: "HR - Family/couple with client present" },
  { value: "HS", label: "HS - Family/couple without client present" },
  { value: "HT", label: "HT - Multi-disciplinary team" },
  { value: "HU", label: "HU - Funded by child welfare agency" },
  { value: "HV", label: "HV - Funded state addictions agency" },
  { value: "HW", label: "HW - Funded by state mental health agency" },
  { value: "HX", label: "HX - Funded by county/local agency" },
  { value: "HY", label: "HY - Funded by juvenile justice agency" },
  { value: "HZ", label: "HZ - Funded by criminal justice agency" },
  {
    value: "KX",
    label:
      "KX - Crisis [used with T1002, H2017 (PSR only, not LPN nursing service), H2019, H0004, and 90832]",
  },
  { value: "Q6", label: "Q6 - Substitute practitioner (locum tenens)" },
  {
    value: "QW",
    label:
      "QW - CLIA waived laboratory procedure or CLIA waived version of a high-or moderate-complexity laboratory procedure",
  },
  {
    value: "SA",
    label:
      "SA - Physician's assistant or clinical nurse specialist, team member (ACT)",
  },
  {
    value: "SE",
    label: "SE - Drug acquired through the 340B drug pricing program",
  },
  { value: "TD", label: "TD - Additional license, registered nurse (RN)" },
  {
    value: "TE",
    label: "TE - Additional license, licensed practical nurse (LPN)",
  },
  { value: "TG", label: "TG - Complex/high-tech level of care" },
  { value: "TS", label: "TS - OTP three-week administration (15-21 days)" },
  { value: "TV", label: "TV - OTP one-week administration (2-7 days)" },
  {
    value: "U1",
    label:
      "U1 - Psychology assistant, psychology assistant intern, psychology assistant trainee / Medicaid level of care 1, as defined by each state",
  },
  {
    value: "U2",
    label:
      "U2 - Licensed professional counselor / Medicaid level of care 2, as defined by each state",
  },
  {
    value: "U3",
    label:
      "U3 - Used to identify the patient location of 'inpatient hospital' when a telehealth service was delivered / Medicaid level of care 3, as defined by each state / Licensed chemical dependency counselor III",
  },
  {
    value: "U4",
    label:
      "U4 - Licensed social worker (LSW) / Used to identify the patient location of 'outpatient hospital' when a telehealth service was delivered / Medicaid level of care 4, as defined by each state",
  },
  {
    value: "U5",
    label:
      "U5 - Licensed marriage and family therapist (LMFT) / Used to identify the patient location of 'nursing facility' when a telehealth service was delivered / Medicaid level of care 5, as defined by each state",
  },
  {
    value: "U6",
    label:
      "U6 - Chemical dependency counselor assistant / Medicaid level of care 6, as defined by each state / Used to identify the patient location of 'Intermediate Care Facility for Individuals with Intellectual Disabilities (ICF/IID)' when a telehealth service was delivered",
  },
  {
    value: "U7",
    label:
      "U7 - Counselor trainee / Medicaid level of care 7, as defined by each state",
  },
  {
    value: "U8",
    label:
      "U8 - Social worker assistant / Medicaid level of care 8, as defined by each state",
  },
  {
    value: "U9",
    label:
      "U9 - Social worker trainee / Medicaid level of care 9, as defined by each state",
  },
  {
    value: "UA",
    label:
      "UA - Marriage and family therapist trainee / Medicaid level of care 10, as defined by each state",
  },
  {
    value: "UB",
    label:
      "UB - Additional license, licensed independent clinical dependency counselor (LICDC) or OTP two-week administration (8-14 days) / Medicaid level of care 11, as defined by each state",
  },
  {
    value: "UC",
    label:
      "UC - Certified nurse practitioner, team member (ACT) / Medicaid level of care 12, as defined by each state",
  },
  {
    value: "UD",
    label: "UD - Medicaid level of care 13, as defined by each state",
  },
  { value: "UE", label: "UE - Used durable medical equipment" },
  {
    value: "UF",
    label: "UF - Additional license, licensed independent social worker (LISW)",
  },
  {
    value: "UG",
    label:
      "UG - Additional license, licensed independent marriage and family therapist (LIMFT)",
  },
  {
    value: "UH",
    label:
      "UH - Additional license, licensed professional clinical counselor (LPCC)",
  },
  { value: "UJ", label: "UJ - Services provided at night" },
  { value: "UK", label: "UK - QMHS with 3 years' experience" },
  { value: "UN", label: "UN - Two patients served" },
  { value: "UP", label: "UP - Three patients served" },
  { value: "UQ", label: "UQ - Four patients served" },
  { value: "UR", label: "UR - Five patients served" },
  { value: "US", label: "US - Six or more patients served" },
  {
    value: "XE",
    label:
      "XE - Service that is distinct because it occurred during a separate encounter",
  },
  {
    value: "XP",
    label:
      "XP - Service that is distinct because it was performed by a different practitioner",
  },
  {
    value: "XS",
    label:
      "XS - Service that is distinct because it was performed on a separate organ/structure",
  },
  {
    value: "XU",
    label:
      "XU - Service that is distinct because it does not overlap usual components of the main service",
  },
];
